module.exports = __webpack_public_path__ + "static/media/filter_small.b002995b.svg";